var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata",style:(_vm.defineStyle)},[_c('div',{staticClass:"nodata-icon",style:({
      backgroundImage: `url(${_vm.imgUrl})`,
    })}),_c('div',{staticClass:"tip"},[_c('div',[_vm._v(_vm._s(_vm.tip))]),_c('div',[_vm._v(_vm._s(_vm.tipLine2))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }